import { api } from '../lib/api'

export type NotificationPrefs = {
  email_system: boolean
  email_product: boolean
  email_commerce: boolean
  email_marketing: boolean
  sms_system: boolean
  sms_product: boolean
  sms_commerce: boolean
  sms_marketing: boolean
  quiet_hours_start: string | null
  quiet_hours_end: string | null
  daily_digest_enabled: boolean
  timezone: string | null
  sms_opted_in: boolean
  sms_optin_timestamp?: string | null
  email_unsub_all: boolean
  last_digest_sent_at?: string | null
}

export async function getNotificationPrefs() {
  const { data } = await api.get<NotificationPrefs>('/api/notifications/prefs/')
  return data
}

export async function updateNotificationPrefs(payload: Partial<NotificationPrefs>) {
  const { data } = await api.patch<NotificationPrefs>('/api/notifications/prefs/', payload)
  return data
}

export type NotificationDevice = {
  id: number
  expo_push_token?: string
  platform?: string
  app_version?: string
  last_seen_at?: string
}

export async function listDevices() {
  const { data } = await api.get<NotificationDevice[]>('/api/notifications/devices/')
  return data
}

export async function deleteDevice(id: number) {
  await api.delete(`/api/notifications/devices/${id}/`)
}
